import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/api";
import { Lock, Loader2 } from "lucide-react";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await signIn(email.trim().toLowerCase(), password);
      toast.success(`Welcome back, ${u.name}`);
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--navy)] px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <img src={LOGO_URL} alt="News-Leader" className="mx-auto h-16 rounded-lg bg-white p-2 object-contain" />
          <p className="font-ui mt-3 text-xs uppercase tracking-[0.2em] text-[var(--gold)]">Staff Content Management</p>
        </div>
        <form onSubmit={submit} data-testid="login-form" className="rounded-2xl bg-white p-8 shadow-2xl">
          <h1 className="font-display text-2xl font-bold text-[var(--navy)]">Sign in to the newsroom</h1>
          <p className="font-serif-body mt-1 text-sm text-slate-500">Reporters & editors only.</p>
          <label className="mt-6 block">
            <span className="font-ui mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="nl-input" placeholder="you@fbnewsleader.com" />
          </label>
          <label className="mt-4 block">
            <span className="font-ui mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Password</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="nl-input" placeholder="••••••••" />
          </label>
          <button type="submit" disabled={busy} data-testid="login-submit" className="font-ui mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[var(--gold)] px-6 py-3 text-xs font-semibold uppercase tracking-wider text-white hover:bg-[#b08f48] disabled:opacity-60">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Lock size={14} />} {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="font-ui mt-4 text-center text-xs text-white/50">© {new Date().getFullYear()} The News-Leader</p>
      </div>
    </div>
  );
}
